export default {
  english: 'English',
  german: 'German',
  dutch: 'Dutch',
  french: 'French',
  spanish: 'Spanish',
  portuguese: 'Portuguese',
  italian: 'Italian',
};
